module.exports = __webpack_public_path__ + "static/media/Icona-6.03a3758c.svg";